import { Location } from 'api/typings'
import api from 'api'

interface LocationsResponse {
  locations: CompanyLocation[]
}

export interface CompanyLocation extends Location {
  hidden: boolean
}

export async function getCompanyLocations(companyId: number) {
  const response = await api.get<LocationsResponse>(
    `/admin/company/${companyId}/locations`
  )
  return response.data.locations
}

export interface UpdateLocationRequest {
  hidden: boolean
}

export async function editCompanyLocation(
  companyId: number,
  locationId: number,
  data: UpdateLocationRequest
) {
  await api.patch(`/admin/company/${companyId}/location/${locationId}`, data)
}
